module.exports = __webpack_public_path__ + "media/images/tmp/slide11-ed9bb61b4fef5b08690d279293a2a59c.jpg";